import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { TSiteVisitSchema } from "../../Models";
import { Control, UseFormStateReturn } from "react-hook-form";
import { JSX } from "react";
import { FormattedNumberInputField } from "@/components/shared";
import { cn } from "@/lib/utils";

interface DayInputComponentProps {
  day: string;
  control: Control<TSiteVisitSchema>;
  errors: UseFormStateReturn<TSiteVisitSchema>["errors"];
}

/**
 * Renders a DayInput component.
 *
 * @param {Object} props - The component props.
 * @param {string} props.day - The day value.
 * @param {Control<TSiteVisitSchema>} props.control - The control function.
 * @param {UseFormStateReturn<TSiteVisitSchema>["errors"]} props.errors - The errors object.
 * @returns {JSX.Element} - The rendered DayInput component.
 */
export const DayInput = ({ day, control, errors }: DayInputComponentProps): JSX.Element => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="flex items-center gap-2">
      <Label className={cn("w-2/6", errors[`${day.toLowerCase()}Night` as keyof TSiteVisitSchema] && "text-red-500")}>
        {t(`common:weekdaysfull.${day.toLowerCase()}`)}
      </Label>
      <div className="grid-2 w-4/6 gap-2">
        <FormattedNumberInputField
          name={`${day.toLowerCase()}Day` as keyof TSiteVisitSchema}
          control={control}
          placeholder={"0"}
          isInteger
        />
        <FormattedNumberInputField
          name={`${day.toLowerCase()}Night` as keyof TSiteVisitSchema}
          control={control}
          placeholder={"0"}
          isInteger
        />
      </div>
    </div>
  );
};
